import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  variants: {
    variant: {
      outline: {
        _placeholder: {
          color: 'blackAlpha.500',
        },
        borderColor: 'gray.200',
        borderRadius: 'md',
        p: 3,
      },
    },
  },
});
